import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "status-success",
  "use": "status-success-usage",
  "viewBox": "0 0 19 19",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 19\" id=\"status-success\"><defs><style>#status-success .cls-1{fill:#fff}</style></defs><title>资源 4</title><g id=\"status-success_图层_2\" data-name=\"图层 2\"><g id=\"status-success_图层_1-2\" data-name=\"图层 1\"><circle class=\"cls-1\" cx=\"9.5\" cy=\"9.5\" r=\"9.5\" /><path d=\"M9.5 1.5a8 8 0 1 0 8 8 8 8 0 0 0-8-8zM14.78 7l-6.07 6a.71.71 0 0 1-1 0L4 9.81a.77.77 0 0 1-.22-.53.68.68 0 0 1 .22-.5.72.72 0 0 1 .94-.06l3.24 2.84L13.77 6a.67.67 0 0 1 .5-.21.72.72 0 0 1 .71.71.71.71 0 0 1-.2.5z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/status-success.svg
// module id = 82HO
// module chunks = 6